var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBinance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.334,
    height: 18.267,
    viewBox: "0 0 91.334 18.267",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "binance",
    transform: "translate(0.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_173",
    "data-name": "Trazado 173",
    d: "M26.475,7.675l3.548-3.546,3.549,3.549,2.063-2.065L30.022,0,24.41,5.612Z",
    transform: "translate(-20.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_174",
    "data-name": "Trazado 174",
    d: "M0,0H2.919V2.919H0Z",
    transform: "translate(-0.005 9.134) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_175",
    "data-name": "Trazado 175",
    d: "M26.457,73.4l3.548,3.548L33.554,73.4l2.065,2.062h0l-5.612,5.614-5.612-5.611,0,0Z",
    transform: "translate(-20.875 -62.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_176",
    "data-name": "Trazado 176",
    d: "M0,0H2.919V2.919H0Z",
    transform: "translate(14.134 9.134) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_177",
    "data-name": "Trazado 177",
    d: "M52.97,50.875,50.876,48.78l-1.548,1.548-.179.177-.366.366,0,0,0,0,2.093,2.092,2.093-2.095h0Z",
    transform: "translate(-41.746 -41.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_72",
    "data-name": "Grupo 72",
    transform: "translate(21.481 4.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_178",
    "data-name": "Trazado 178",
    d: "M148.37,30.68h4.49a3.407,3.407,0,0,1,2.528.866,2.236,2.236,0,0,1,.662,1.633v.027a2.4,2.4,0,0,1-.1.733,2.251,2.251,0,0,1-.276.577,2.131,2.131,0,0,1-.4.45,2.585,2.585,0,0,1-.489.332,3.269,3.269,0,0,1,1.323.866,2.217,2.217,0,0,1,.482,1.515v.027a2.516,2.516,0,0,1-.255,1.163,2.268,2.268,0,0,1-.731.831,3.47,3.47,0,0,1-1.147.5,6.16,6.16,0,0,1-1.485.166h-4.6Zm4.04,3.916a2.22,2.22,0,0,0,1.121-.242.837.837,0,0,0,.413-.782v-.027a.856.856,0,0,0-.359-.74,1.778,1.778,0,0,0-1.037-.255h-2.1V34.6Zm.567,3.9a2.049,2.049,0,0,0,1.111-.255.877.877,0,0,0,.4-.8v-.027a.91.91,0,0,0-.374-.768,1.98,1.98,0,0,0-1.2-.289h-2.466V38.5Z",
    transform: "translate(-148.37 -30.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_179",
    "data-name": "Trazado 179",
    d: "M223.88,30.68h2.131v9.687H223.88Z",
    transform: "translate(-212.986 -30.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_180",
    "data-name": "Trazado 180",
    d: "M261,30.68h1.965l4.542,5.961V30.68h2.1v9.687H267.8l-4.69-6.158v6.158H261Z",
    transform: "translate(-244.75 -30.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_181",
    "data-name": "Trazado 181",
    d: "M340.772,30.2h1.962l4.151,9.756H344.66l-.886-2.173h-4.1l-.886,2.173H336.62Zm2.242,5.7-1.29-3.142L340.44,35.9Z",
    transform: "translate(-309.46 -30.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_182",
    "data-name": "Trazado 182",
    d: "M423.74,30.68h1.965l4.539,5.961V30.68h2.1v9.687h-1.814l-4.69-6.158v6.158h-2.1Z",
    transform: "translate(-384.011 -30.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_183",
    "data-name": "Trazado 183",
    d: "M507.088,39.576a5.039,5.039,0,0,1-1.979-.387,4.785,4.785,0,0,1-2.616-2.643,5.127,5.127,0,0,1-.374-1.952v-.027a5.026,5.026,0,0,1,1.413-3.536,4.793,4.793,0,0,1,1.587-1.079,5.179,5.179,0,0,1,2.047-.394,6.418,6.418,0,0,1,1.238.111,5.145,5.145,0,0,1,1.019.3,4.4,4.4,0,0,1,.844.47,5.7,5.7,0,0,1,.721.609l-1.355,1.564a5.153,5.153,0,0,0-1.154-.8,2.953,2.953,0,0,0-1.322-.289,2.681,2.681,0,0,0-2.02.886,3.043,3.043,0,0,0-.583.962,3.3,3.3,0,0,0-.206,1.17v.027a3.349,3.349,0,0,0,.206,1.169,3.075,3.075,0,0,0,.577.968,2.663,2.663,0,0,0,2.02.9,2.96,2.96,0,0,0,1.4-.3,5.427,5.427,0,0,0,1.141-.831l1.356,1.371a6.919,6.919,0,0,1-.775.721,4.617,4.617,0,0,1-.879.547,4.553,4.553,0,0,1-1.045.345,6.218,6.218,0,0,1-1.267.121Z",
    transform: "translate(-451.082 -29.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_184",
    "data-name": "Trazado 184",
    d: "M581.47,30.68h7.29v1.9h-5.194v1.965h4.573v1.9h-4.566v2.034h5.259v1.9h-7.358Z",
    transform: "translate(-518.984 -30.518)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBinance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/binance.2ea847f67ede4cfb4ddca760e1c835ae.svg";